import { message } from 'antd';
// Global message configuration
const initializeMessageConfig = () => {
  message.config({
    top: 55,
    duration: 1,
    className: 'custom-message',
    maxCount: 1,
  });
};

export default initializeMessageConfig; 